import { useState } from "react";
import { useAuthContext } from "../hooks/useAuthContext";
import { auth } from "../utils/apiUtils";

export const useSignup = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { dispatch } = useAuthContext();

  const signup = async (credentials) => {
    setLoading(true);
    setError(null);
    const response = await auth.post("signup", credentials);

    if (response?.data) {
      window.localStorage.setItem("user", JSON.stringify(response?.data));

      dispatch({ type: "LOGIN", payload: response.data });
      setLoading(false);
    }
  };

  return { signup, loading, error };
};
